var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ad07893e467b3e9d0af1537422e7180.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4131a0b6f68048e9ef43d6eb7b4b44d6.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5e68eec2466da05e93e40e91ae92287a.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6d47082ce4a5ca335df9b48a97f2ab55.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7450ebe4b4da39dd271b67e48111bd50.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7dbc18cd1fa456cad87c9c81826e7ab2.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/96a79120d4c21e146863fc5d8f598275.js').default;
var scope_7 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d38a5cbf0eae52ce75c103b950f3e64c.js').default;
var scope_8 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d9d81bc7230bd767e4af9dfccdc432c1.js').default;
var scope_9 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fb2f5b4ab31827f9aeddb13493638a00.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    